import IdsToast from './ids-toast';

export interface IdsToastServiceSettings {
  id?: string;
  title?: string;
  message?: string;
  messageId?: string;
  closeButtonLabel?: string;
  allowLink?: boolean;
  audible?: boolean;
  draggable?: boolean;
  position?: string;
  progressBar?: boolean;
  savePosition?: boolean;
  timeout?: number;
  uniqueId?: string;
  destroyOnComplete?: boolean;
}

/**
 * IDS Toast Service
 */
export default class IdsToastService {
  /* Show a toast notification */
  static show(settings: IdsToastServiceSettings) {
    const toast = document.createElement('ids-toast') as IdsToast;
    if (settings.id) toast.setAttribute('id', settings.id);
    if (settings.draggable) toast.draggable = settings.draggable;
    if (settings.position) toast.position = settings.position;
    if (settings.savePosition) toast.savePosition = settings.savePosition;
    if (settings.uniqueId) toast.uniqueId = settings.uniqueId;
    if (settings.destroyOnComplete) toast.destroyOnComplete = settings.destroyOnComplete;

    document.body.appendChild(toast);
    toast.show(settings);
  }

  /* Hide a toast notification by id */
  static hide(id: string) {
    const toast = document.querySelector(`#${id}`) as IdsToast;
    toast?.clearPosition();
  }

  /* Hide all toast notifications */
  static hideAll() {
    const toasts = document.querySelectorAll('ids-toast');
    toasts.forEach((toast) => {
      (toast as IdsToast).clearPositionAll();
    });
  }
}
